'use client';

import { createContext } from 'react';

import { DefaultImage } from '@repo/sds/providers/SDSProvider/defaults/DefaultImage';
import { DefaultLink } from '@repo/sds/providers/SDSProvider/defaults/DefaultLink';
import type { SDSContextValue, SDSLocationAPI, SDSNavigationAPI } from '@repo/sds/providers/SDSProvider/types';

// Default navigation using browser APIs (fallback when no framework-specific navigation is provided)
export const defaultNavigation: SDSNavigationAPI = {
  navigate: (path: string) => {
    if (typeof window !== 'undefined') {
      window.location.href = path;
    }
  },
  replace: (path: string) => {
    if (typeof window !== 'undefined') {
      window.location.replace(path);
    }
  },
  back: () => {
    if (typeof window !== 'undefined') {
      window.history.back();
    }
  },
};

export const defaultLocation: SDSLocationAPI = {
  pathname: typeof window !== 'undefined' ? window.location.pathname : '/',
};

// Create context with the type-safe default value.
export const SDSContext = createContext<SDSContextValue>({
  linkComponent: DefaultLink,
  imageComponent: DefaultImage,
  navigation: defaultNavigation,
  location: defaultLocation,
});
